import React from "react";

export default function Twenty({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path d="M55.59,245.23H49.28a5.48,5.48,0,0,0-5.47,5.47v34a5.48,5.48,0,0,0,5.47,5.47h6.31Z" />
      <path d="M251.65,245.23H125v44.91H251.65a5.49,5.49,0,0,0,5.47-5.47v-34A5.49,5.49,0,0,0,251.65,245.23Z" />
      <path d="M113.42,235.58H67A8.45,8.45,0,0,0,58.57,244v46.4A8.45,8.45,0,0,0,67,298.88h46.4a8.45,8.45,0,0,0,8.45-8.45V244A8.45,8.45,0,0,0,113.42,235.58Zm-10.78,27.31V285a4,4,0,0,1-3.93,3.93h-17A4,4,0,0,1,77.8,285V250.42a4,4,0,0,1,3.94-3.93h17a4,4,0,0,1,3.93,3.93Z" />
      <path d="M90.18,282.07a2.57,2.57,0,0,0-2.59,2.59,2.59,2.59,0,1,0,2.59-2.59Z" />
      <path d="M86.91,252.44h6.53a1.83,1.83,0,0,0,1.82-1.83,1.89,1.89,0,0,0-1.82-1.82H87a1.85,1.85,0,0,0-1.92,1.82A1.83,1.83,0,0,0,86.91,252.44Z" />
      <polygon points="80.58 280.44 99.67 280.44 99.67 255.12 80.58 254.93 80.58 280.44" />
      {children}
    </svg>
  );
}
